import type { FC } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import Link from '@atlaskit/link';

const i18n = defineMessages({
	parentAccessWarningMessage: {
		id: 'share-and-restrict-dialog.principal-details-warning.principal-details-warning.no-ancestor-permission',
		defaultMessage: 'Needs access to a <parentLink>parent</parentLink> first.',
		description:
			'The warning message in the share and restrict dialog appears when the user lacks permission for one of the ancestor pages.',
	},
});

export const ParentAccessWarning: FC<{
	parentLink: {
		webui: string | null | undefined;
		base: string | null | undefined;
	} | null;
}> = ({ parentLink }) => {
	const getStyledButton = (chunks: React.ReactNode[]) => {
		const { base, webui } = parentLink || {};

		if (!base || !webui) {
			return chunks;
		}

		return (
			<Link href={`${base}${webui}`} appearance="default" target="_blank">
				{chunks}
			</Link>
		);
	};

	return (
		<FormattedMessage
			{...i18n.parentAccessWarningMessage}
			values={{
				parentLink: (chunks: React.ReactNode[]) => getStyledButton(chunks),
			}}
		/>
	);
};
